<div class="map-menu-item">
  <div class="header">
    <h3 class="p-0 border-0">Premium Map</h3>
  </div>

  <div (click)="$event.stopPropagation()" role="radiogroup"
       *ngIf="selectedMapLayer$ | async as selectedMapLayer"
       class="custom-control-stacked">
    <label *ngFor="let layer of premiumLayers$ | async;  trackBy: trackByFn"
           class="custom-control custom-radio d-flex align-items-center">
      <input [value]="layer.layerId"
             (change)="togglePremium(layer)"
             [checked]="layer.layerId === selectedMapLayer[0]?.layerId"
             [disabled]="layersLimitReached && !layer.isSelected"
             tabindex="0"
             type="radio"
             name="trend-layer"
             class="custom-control-input radio-primary">
      <span class="custom-control-indicator"></span>
      <span class="custom-control-description">{{layer.label}}</span>
      <p class="text-danger m-0 p-0 zoom-icon" *ngIf="(premiumMinScaleExceeded$ | async) && (layer.layerId != 'select_none')" rlstTooltip="Zoom In" [tooltipPosition]="'above'">
        <i class="far fa-search-plus" aria-hidden="true"></i>
        <span class="sr-only">Zoom In</span>
      </p>
      <p class="text-danger m-0 p-0 zoom-icon" *ngIf="layer.needZoomOut" rlstTooltip="Zoom Out" [tooltipPosition]="'above'">
        <i class="far fa-search-minus" aria-hidden="true"></i>
        <span class="sr-only">Zoom Out</span>
      </p>
    </label>
  </div>
  <div class="info-lane">
    <rlst-map-layers-info-footer></rlst-map-layers-info-footer>
  </div>
</div>
